// extracted by mini-css-extract-plugin
export default {"text_input":"StyleButton_text_input__x9Hrj","button":"StyleButton_button__3wR8M"};